<template>
    <TransitionRoot as="template" :show="open">
        <Dialog class="relative z-50" @close="close">
            <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in duration-200"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-50 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                            <div class="mx-auto flex size-12 items-center justify-center rounded-full bg-yellow-100">
                                <CloudIcon class="size-6 text-yellow-600" aria-hidden="true" />
                            </div>
                            <div class="mt-3 text-center sm:mt-5">
                                <DialogTitle as="h3" class="text-base font-semibold text-gray-900">
                                    {{ title }}
                                </DialogTitle>
                                <div class="mt-2">
                                    <p class="text-sm text-gray-500">
                                        {{ description }}
                                    </p>
                                </div>
                            </div>
                            <div class="mt-5 sm:mt-6">
                                <router-link
                                    to="/subscription"
                                    class="inline-flex w-full justify-center rounded-md bg-royal-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-500"
                                >
                                    {{ buttonText }}
                                </router-link>
                                <button
                                    type="button"
                                    class="mt-2 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 cursor-pointer"
                                    @click="close"
                                >
                                    {{ $t('upload_limit_modal.close') }}
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionChild,
    TransitionRoot
} from '@headlessui/vue';
import { CloudIcon } from '@heroicons/vue/24/solid';

export default defineComponent({
    name: "UploadLimitModalAlertComponent",

    components: {
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CloudIcon
    },

    props: {
        open: {
            type: Boolean,
            required: true
        },
        type: {
            type: String,
            default: 'storage_limit'
        }
    },

    computed: {
        title(): string {
            return this.$t(`upload_limit_modal.title.${this.type}`) as string;
        },
        description(): string {
            return this.$t(`upload_limit_modal.description.${this.type}`) as string;
        },
        buttonText(): string {
            return this.$t(`upload_limit_modal.button.${this.type}`) as string;
        }
    },

    methods: {
        close() {
            this.$emit('close');
        }
    }
});
</script>
